import { render } from "./GetOTP.vue?vue&type=template&id=0f0b77e9&scoped=true"
import script from "./GetOTP.vue?vue&type=script&lang=js"
export * from "./GetOTP.vue?vue&type=script&lang=js"

import "./GetOTP.vue?vue&type=style&index=0&id=0f0b77e9&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0b77e9"]])

export default __exports__